export default {
  label: 'Charge the service fee on table orders',
  description: 'Table orders pay no service fee unless this is on.',
  no_fee: 'Your restaurant charges no service fee, so table orders pay none either.',
  partner_default_on: 'Partner default: on',
  partner_default_off: 'Partner default: off',
  toasts: {
    on: 'Table orders now pay the service fee',
    off: 'Table orders now pay no service fee',
    error: 'That didn’t save. Please try again.',
  },
};
